import * as React from 'react';
import classnames from 'classnames';
import inject from '../../jss/index';
import styles from './Row.jss';
export var Row = function Row(_ref) {
  var children = _ref.children,
    classes = _ref.classes,
    padded = _ref.padded,
    style = _ref.style;
  return React.createElement("div", {
    style: style,
    className: classnames(classes.Row, padded && classes.Padded)
  }, children);
};
Row.styleRoot = 'Row';
Row.defaultProps = {
  padded: false
};
export default inject(styles)(Row);